import { memo } from 'react';

const NoCategories = () => (
  <svg
    width="165"
    height="171"
    viewBox="0 0 165 171"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M82.5055 160.147C125.631 160.147 160.605 125.436 160.605 82.5733C160.605 39.7108 125.631 5 82.5055 5C39.38 5 4.40625 39.7108 4.40625 82.5733C4.40625 125.436 39.38 160.147 82.5055 160.147Z"
      fill="#EAEEF9"
    />
    <path
      d="M142.329 72.4497V119.914C142.329 129.775 134.309 137.795 124.317 137.795H40.9581C31.0971 137.795 23.0768 129.907 22.9453 120.046C22.9453 119.914 22.9453 119.914 22.9453 119.783V72.4497C22.9453 72.3182 22.9453 72.3182 22.9453 72.1867C22.9453 71.9238 22.9453 71.6608 23.0768 71.3978C23.2083 71.0034 23.3398 70.7404 23.4712 70.346L45.8229 27.615C46.6117 25.9057 48.321 24.9854 50.1617 24.9854H114.981C116.822 24.9854 118.4 25.9057 119.32 27.615L141.672 70.346C141.803 70.609 141.935 71.0034 142.066 71.3978C142.329 71.6608 142.329 72.0552 142.329 72.4497Z"
      fill="url(#paint0_linear_3119_346043)"
    />
    <g filter="url(#filter0_d_3119_346043)">
      <path
        d="M99.7286 72.8437H65.9382C64.4919 72.8437 63.3086 71.7919 63.3086 70.2141V24.0646C63.3086 22.6183 64.3604 21.435 65.9382 21.435H99.5971C101.043 21.435 102.227 22.4868 102.227 24.0646V70.2141C102.227 71.6604 101.175 72.8437 99.7286 72.8437Z"
        fill="#F5F8FF"
      />
    </g>
    <g filter="url(#filter1_d_3119_346043)">
      <path
        d="M110.906 83.7563H54.7636C52.9228 83.7563 51.4766 82.1786 51.4766 80.4693V35.6346C51.4766 33.7939 53.0543 32.3476 54.7636 32.3476H110.906C112.746 32.3476 114.193 33.9254 114.193 35.6346V80.4693C114.061 82.31 112.746 83.7563 110.906 83.7563Z"
        fill="#F5F8FF"
      />
    </g>
    <g filter="url(#filter2_d_3119_346043)">
      <path
        d="M117.349 96.5103H48.4529C46.4807 96.5103 44.7715 94.8011 44.7715 92.9603V48.783C44.7715 46.8108 46.4807 45.233 48.4529 45.233H117.349C119.321 45.233 121.03 46.9423 121.03 48.783V92.8288C120.898 94.9325 119.321 96.5103 117.349 96.5103Z"
        fill="#F5F8FF"
      />
    </g>
    <g filter="url(#filter3_d_3119_346043)">
      <path
        d="M124.316 108.869H41.4835C39.2483 108.869 37.5391 107.029 37.5391 105.056V61.5366C37.5391 59.3014 39.3798 57.7236 41.4835 57.7236H124.316C126.551 57.7236 128.26 59.5644 128.26 61.5366V104.925C128.129 107.16 126.551 108.869 124.316 108.869Z"
        fill="#F5F8FF"
      />
    </g>
    <path
      d="M99.4671 74.947H68.3063C67.5174 74.947 66.7285 74.2896 66.7285 73.3693C66.7285 72.5804 67.3859 71.7915 68.3063 71.7915H99.4671C100.256 71.7915 101.045 72.4489 101.045 73.3693C101.045 74.2896 100.387 74.947 99.4671 74.947Z"
      fill="#E6ECF5"
    />
    <path
      d="M90.3937 84.1513H50.9497C50.4237 84.1513 50.0293 83.7568 50.0293 83.2309C50.0293 82.705 50.4237 82.3105 50.9497 82.3105H90.2622C90.7881 82.3105 91.1826 82.705 91.1826 83.2309C91.4455 83.4939 91.0511 84.1513 90.3937 84.1513Z"
      fill="#E6ECF5"
    />
    <path
      d="M116.295 84.1513H96.4418C95.9159 84.1513 95.5215 83.7568 95.5215 83.2309C95.5215 82.705 95.9159 82.3105 96.4418 82.3105H116.164C116.69 82.3105 117.084 82.705 117.084 83.2309C117.347 83.4939 116.953 84.1513 116.295 84.1513Z"
      fill="#E6ECF5"
    />
    <g filter="url(#filter4_d_3119_346043)">
      <path
        d="M135.468 74.829V119.829C135.468 126.23 130.348 131.35 123.831 131.35H41.4417C35.0413 131.35 29.8047 126.23 29.8047 119.829V74.5962C29.8047 74.3635 29.8047 74.1307 29.9211 73.898H52.509C56.4655 73.898 59.7239 77.04 59.7239 81.1129C59.7239 83.0912 60.5385 84.9531 61.8185 86.2332C63.215 87.6296 64.8442 88.3279 66.9388 88.3279H99.7655C103.722 88.3279 106.98 85.1859 106.98 81.1129C106.98 79.1347 107.795 77.2727 109.075 75.9927C110.472 74.5962 112.101 73.898 114.079 73.898H135.236C135.468 74.1307 135.468 74.4799 135.468 74.829Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter5_d_3119_346043)">
      <path
        d="M142.329 72.4493V124.778C142.329 132.01 136.544 137.795 129.181 137.795H36.0933C28.8619 137.795 22.9453 132.01 22.9453 124.778V72.1863C22.9453 71.9234 22.9453 71.6604 23.0768 71.3975H53.0543C57.5246 71.3975 61.206 74.9474 61.206 79.5492C61.206 81.7844 62.1264 83.8881 63.5727 85.3344C65.1504 86.9121 66.9912 87.701 69.3578 87.701H96.0483C100.519 87.701 104.2 84.151 104.2 79.5492C104.2 77.3141 105.12 75.2104 106.567 73.7641C108.144 72.1863 109.985 71.3975 112.22 71.3975H142.066C142.329 71.6604 142.329 72.0549 142.329 72.4493Z"
        fill="url(#paint1_linear_3119_346043)"
      />
    </g>
    <path
      d="M129.181 118.862H102.096C101.176 118.862 100.387 118.204 100.387 117.153C100.387 116.232 101.044 115.443 102.096 115.443H128.918C129.838 115.443 130.627 116.101 130.627 117.153C130.759 117.941 129.97 118.862 129.181 118.862Z"
      fill="#E6ECF5"
    />
    <path
      d="M117.085 127.145H102.096C101.176 127.145 100.387 126.487 100.387 125.435C100.387 124.515 101.044 123.726 102.096 123.726H116.953C117.874 123.726 118.662 124.383 118.662 125.435C118.794 126.224 118.005 127.145 117.085 127.145Z"
      fill="#E6ECF5"
    />
    <path
      d="M107.76 132.667C107.234 134.903 106.445 137.269 105.525 139.241C103.027 144.106 99.0824 147.919 94.2177 150.417C89.2214 152.915 83.3048 153.967 77.3882 152.652C63.3198 149.628 54.3792 136.086 57.2717 122.149C60.1643 108.212 73.7068 99.14 87.6437 102.164C92.6399 103.216 96.9787 105.714 100.66 109.132C106.971 115.312 109.469 124.121 107.76 132.667Z"
      fill="url(#paint2_linear_3119_346043)"
    />
    <path
      d="M90.6578 125.041H84.7412V119.125C84.7412 117.942 83.8209 116.89 82.5061 116.89C81.3228 116.89 80.2709 117.81 80.2709 119.125V125.041H74.3543C73.171 125.041 72.1191 125.962 72.1191 127.277C72.1191 128.591 73.0395 129.512 74.3543 129.512H80.2709V135.428C80.2709 136.612 81.1913 137.664 82.5061 137.664C83.6894 137.664 84.7412 136.743 84.7412 135.428V129.512H90.6578C91.8412 129.512 92.893 128.591 92.893 127.277C92.893 125.962 91.8412 125.041 90.6578 125.041Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_3119_346043"
        x="41.3086"
        y="0.434998"
        width="82.918"
        height="95.4088"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346043"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346043"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3119_346043"
        x="29.4766"
        y="11.3476"
        width="106.717"
        height="95.4088"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346043"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346043"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_3119_346043"
        x="22.7715"
        y="24.233"
        width="120.258"
        height="95.2773"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346043"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346043"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_3119_346043"
        x="15.5391"
        y="36.7236"
        width="134.721"
        height="95.1458"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346043"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346043"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_3119_346043"
        x="16.8047"
        y="57.898"
        width="131.664"
        height="83.452"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-3" />
        <feGaussianBlur stdDeviation="6.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346043"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346043"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_3119_346043"
        x="0.945312"
        y="60.3975"
        width="163.385"
        height="110.397"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346043"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346043"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3119_346043"
        x1="82.6467"
        y1="28.9042"
        x2="82.6467"
        y2="92.2233"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3119_346043"
        x1="82.5984"
        y1="69.8616"
        x2="82.5984"
        y2="138.511"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3119_346043"
        x1="82.5105"
        y1="103.376"
        x2="82.5105"
        y2="132.361"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

const NoCategoriesIcon = memo(NoCategories);
export default NoCategoriesIcon;
